import React from 'react';
import { Grid } from '@material-ui/core';
import { Text, Colors } from 'library';

const JobCardDetailRow = ({ icon, text, visible }: { icon: React.ReactNode; text?: string; visible: boolean }) => {
    return visible ? (
        <Grid container alignItems="center" direction="row" style={styles.row}>
            <Grid container direction="column" alignItems="center" justify="center" style={styles.box}>
                {icon}
            </Grid>
            <Text textStyle={styles.text} variant="body1">
                {text || ''}
            </Text>
        </Grid>
    ) : null;
};

const styles = {
    row: {
        marginBottom: 12,
    },
    text: {
        marginLeft: 8,
    },
    box: {
        borderRadius: 20,
        width: 28,
        height: 28,
        backgroundColor: Colors.lightTurq,
    },
};

export default JobCardDetailRow;
